import { defineMessages } from 'react-intl-next';

export default defineMessages({
    errorMessageContentWithRetryNonFinal: {
        defaultMessage: 'Message failed to send. <link>Try again</link>',
        description:
            'Error message content when the request to send a message to the virtual agent fails, this message includes a link to retry sending the message.',
        id: 'help-centre-virtual-agent.conversation.message-renderer.error-message.error-message-content-with-retry-non-final',
    },
    errorMessageContentNonFinal: {
        defaultMessage: 'Message failed to send.',
        description: 'Error message content when the request to send a message to the virtual agent fails.',
        id: 'help-centre-virtual-agent.conversation.message-renderer.error-message.error-message-content-non-final',
    },
});
